<template>
    <div class="container offset pb-2">
        <form @submit.prevent="createMember()">
            <div class="custom-form">
                <img
                class="image-style"
                src="../../assets/img/Dados/ListarMembros/icon-add-user.png"
                />

                <div class="form-group">
                    <label class="question-style">E-mail:</label>
                    <div class="form-control d-flex flex-wrap email-field">
                        <ul class="d-flex flex-wrap mb-0">
                            <li class="mr-2 my-1 px-1 tag d-flex" v-for="(tag,index) in tags" :key="tag">
                                <div>
                                    {{tag}}
                                </div>
                                <div @click="remove(index)" class="ml-2 remove-icon">
                                    <i class="fas fa-times"></i>
                                </div>
                            </li>
                        </ul>
                        <div class="flex-grow-1 d-flex align-items-center">
                            <input class="email-input w-100"
                                @input="verifyValidadeEmail()"
                                @keypress="keyEvent($event)" @blur="keyEvent($event)"
                                v-model="email"
                                type="email" multiple
                                placeholder="Digite o e-mail.."
                            />
                        </div>
                    </div>
                    <span
                        v-if="isValidEmail !== 'true' && validateEmail(email)"
                        class="text-alert-match-passwords"
                        ><b>Usuário já se encontra na plataforma</b></span
                    >
                    <span
                        v-else-if="isValidEmail === 'true' && validateEmail(email) && !tags.includes(email)"
                        class="text-alert-valid-email"
                        ><b>Email pode ser convidado.</b></span
                    >
                    <span
                        v-else-if="tags.includes(email)"
                        class="text-alert-match-passwords"
                        ><b>Email já inserido.</b></span
                    >

                    <div class="d-flex justify-content-start align-items-center mt-2 row">
                        <div class="col-12">
                            <label class="text-align-left" for="cargo">Cargo:</label>
                            <select
                                v-model="cargo"
                                class="form-control"
                                id="cargo"
                                required
                            >
                                <option :value="6" v-if="data.id_permissao ==6">Administrador Estadual</option>
                                <option :value="5" v-if="data.id_permissao >=5">Administrador Regional</option>
                                <option :value="4" v-if="data.id_permissao >=4">Administrador Municipal</option>
                                <option :value="3" v-if="data.id_permissao >=5">Assistente de campo</option>
                                <option :value="2" v-if="data.id_permissao >=4">Gestor Escolar</option>
                                <option :value="1" v-if="data.id_permissao == 3 || data.id_permissao >=5">Aplicador</option>       
                            </select>
                        </div>
                    </div>

                    <div class="d-flex justify-content-start align-items-center mt-2" v-if="cargo >= 1 && cargo <6">
                        <div>
                            <label class="text-align-left" for="regional">Regional:</label>
                            <select
                                v-model="regionaisData"
                                class="form-control"
                                id="regional"
                                required
                            >
                                <option
                                v-for="regional in regionais"
                                :key="regional.nome"
                                :value="regional.idRegional"
                                >
                                {{ regional.nome }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="d-flex justify-content-start align-items-center mt-2 row" v-if="cargo <= 4 && regionaisData">
                        <div class="col-6">
                            <label class="text-align-left" for="municipio">Municipio:</label>
                            <select
                                v-model="municipioData"
                                class="form-control"
                                id="municipio"
                                required
                            >
                                <option
                                v-for="municipio in municipios"
                                :key="municipio.nome"
                                :value="municipio.idMunicipio"
                                >
                                {{ municipio.nome }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="d-flex justify-content-start align-items-center mt-2" v-if="cargo == 2 && municipioData">
                        <div>
                            <label class="text-align-left" for="ue">Unidade Educacional:</label>
                            <select
                                v-model="ueData"
                                class="form-control"
                                id="ue"
                                required
                            >
                                <option
                                v-for="ue in ues"
                                :key="ue.nome"
                                :value="ue.idue"
                                >
                                {{ ue.nome }} - {{ue.idue}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="button-div pt-2" v-if="data.id_permissao >= 3">
                <Button
                section="orange-outline"
                value="Convidar Membro"
                :isOutline="true"
                :hasIcon="true"
                iconName="paper-plane"
                />
            </div>
        </form>
    </div>
</template>

<script>
    import Button from "../../components/Button";
    import { Notyf } from "notyf";
    const notyf = new Notyf({
        duration: 5000,
        position: {
            x: "left",
            y: "bottom",
        },
    });

    export default {
        name: "AddUser",
        props: {
            data: Object,
        },
        data() {
            return {
                email: "",
                regionaisData: "",
                // municipio: '',
                cargo:"",
                municipioData: "",
                regional: '',
                ueData: "",
                apagar:"",
                tags:[],
            };
        },
        async created() {
            const loggedPerm = await this.$store.getters.getUserPerm
            this.apagar = loggedPerm

            /*--------------------------------
            |Obtém todas as regionais com base no usuario selecionado
            ----------------------------------*/
            if(loggedPerm.id_permissao == 4 || loggedPerm.id_permissao == 3) {
                const payloadGetRegionalByMunicipio = {
                    id_municipio: loggedPerm.id_municipio
                };
                await this.$store.dispatch("setRegionalByMunicipio",payloadGetRegionalByMunicipio);
                this.regional = await this.$store.getters.getRegional;

            } else if(loggedPerm.id_permissao == 5) {
                const payload = {
                    idRegional: loggedPerm.id_regional
                };
                await this.$store.dispatch("setRegionalUnica", payload);
                this.regional = await this.$store.getters.getRegionalUnica;

            } else if(loggedPerm.id_permissao == 6) {
                await this.$store.dispatch("setRegionais");
            }
        },
        computed: {
            isValidEmail() {
                return this.$store.getters.getIsValidEmail;
            },

            /*--------------------------------
            |Retornar as Regionais
            ----------------------------------*/
            regionais() {
            if(this.regional){
                if (this.data.id_permissao == 5){
                    return this.$store.getters.getRegionais.filter(element => element.idRegional == this.regional.idRegional);
                }//4 e 3
                else return this.$store.getters.getRegionais.filter(element => element.idRegional == this.regional.id_regional);
            }
            else
                return this.$store.getters.getRegionais;
            },

            /*--------------------------------
            |Retornar os municipios
            ----------------------------------*/
            municipios() {
            if(this.data.id_permissao == 4){
                return this.$store.getters.getMunicipios.filter(element => element.idMunicipio == this.data.id_municipio);
            }
            else
            return this.$store.getters.getMunicipios;
            },

            /*--------------------------------
            |Retornar as UEs
            ----------------------------------*/
            ues() {
                return this.$store.getters.getListUE;
            },

        },
        watch:{
            /*--------------------------------
            |setar as opçoes de municipios de acordo com a regional selecionada
            ----------------------------------*/
            regionaisData(){
                this.resetMunicipioData();
                const payloadRegMun = {
                    id_regional: this.regionaisData
                };
                this.$store.dispatch("setRegionalMunicipios", payloadRegMun);
            },

            /*--------------------------------
            |setar as opçoes de UE de acordo com o municipio selecionado
            ----------------------------------*/
            municipioData(){
                this.ueData = ""
                if(this.municipioData.length>0){
                    const payloadMunUe = {
                        idMunicipio: this.municipioData
                    };
                    this.$store.dispatch("setListUE", payloadMunUe);
                }
            }
        },
        methods: {
            remove(index){
                this.tags.splice(index, 1);
            },

            resetMunicipioData(){
                this.municipioData = ""
            },

            //FORMATO DO EMAIL VÁLIDO
            validateEmail(email) {
                var re = /\S+@\S+\.\S+/;
                return re.test(email);
            },

            //SE FORMATO VÁLIDO, VERIFICA SE O EMAIL ESTÁ NA PLATAFORMA
            async verifyValidadeEmail() {
                if (this.validateEmail(this.email)) {
                    await this.$store.dispatch("setIsValidEmail", this.email);
                }
            },

            async keyEvent(event){
                if (this.validateEmail(this.email)) {
                    if(this.isValidEmail === 'true'){
                        if((event.key == 'Enter' || event.key == ',' || event.key == ' ') || event.type=="blur"){ 
                            if(this.tags.includes(this.email)){
                            notyf.open({
                                type: "error", message: "Email já inserido", });
                            }
                            else{
                            this.tags.push(this.email);
                            this.email = ''; 
                            }
                            event.preventDefault();
                        }
                    }
                }
            },

            /*--------------------------------
            |CRIAR MEMBRO
            ----------------------------------*/
            async createMember() {

                //FORMATO VÁLIDO E NOTIFICAÇÃO
                if(this.tags.length <= 0){
                    notyf.open({
                    type: "error", message: "Não há emails válidos", });
                    return;
                }

                else if(this.email.length >0){
                    notyf.open({
                    type: "error", message: "Um ou mais emails são inválidos", });
                    return;
                }

                else{
                    // SWITCH PARA CRIAR MEMBRO DE ACORDO COM A PERMISSAO CORRETA
                    switch(this.cargo){
                        case 6:{
                            /*--------------------------------
                            |ESTADUAL
                            ----------------------------------*/
                            // Registrando informações do payload
                            this.tags.forEach(async element => {
                                const payload = {
                                    userMails: JSON.parse(JSON.stringify([element])),
                                    idPermissao: this.cargo,
                                };
                                await this.$store.dispatch("setInviteEstadualUser", payload);
                            });
                            break;
                        }

                        case 5:{
                            /*--------------------------------
                            |REGIONAL
                            ----------------------------------*/
                            // Registrando informações do payload
                            this.tags.forEach(async element => {
                                const payload = {
                                    idRegional: this.regionaisData,
                                    userMails: JSON.parse(JSON.stringify([element])),
                                    idPermissao: this.cargo,
                                };
                                await this.$store.dispatch("setNotifyInstiInviteUser", payload);
                            });
                            break;
                        }

                        case 4:{
                            /*--------------------------------
                            |MUNICIPAL
                            ----------------------------------*/
                            // Registrando informações do payload
                            this.tags.forEach(async element => {
                                const payloadMunicipal = {
                                    idRegional: this.regionaisData,
                                    idMunicipio: this.municipioData,
                                    userMails: JSON.parse(JSON.stringify([element])),
                                    idPermissao: this.cargo,
                                };
                                await this.$store.dispatch("setNotifyMunicInviteUser", payloadMunicipal);
                            });
                            break;
                        }

                        case 3:{
                            /*--------------------------------
                            |ASSISTENTE DE CAMPO
                            ----------------------------------*/
                            this.tags.forEach(async element => {
                                const payloadAssistente = {
                                    idRegional: this.regionaisData,
                                    idMunicipio: this.municipioData,
                                    userMails: JSON.parse(JSON.stringify([element])),
                                    idPermissao: this.cargo,
                                };
                                await this.$store.dispatch("setNotifyMunicInviteUser", payloadAssistente);
                            });
                            break;
                        }

                        case 2:{
                            /*--------------------------------
                            |GESTOR ESCOLAR
                            ----------------------------------*/
                            // Registrando informações do payload
                            this.tags.forEach(async element => {
                                const payloadUe = {
                                    idRegional: this.regionaisData,
                                    idMunicipio: this.municipioData,
                                    idUe: this.ueData,
                                    userMails: JSON.parse(JSON.stringify([element])),
                                    idPermissao: this.cargo,
                                };
                                await this.$store.dispatch("setNotifyUeInviteUser", payloadUe);
                            });
                            break;
                        }

                        case 1:{
                            /*--------------------------------
                            |APLICADOR
                            ----------------------------------*/
                            this.tags.forEach(async element => {
                                const payloadAplicador = {
                                    idRegional: this.regionaisData,
                                    idMunicipio: this.municipioData,
                                    userMails: JSON.parse(JSON.stringify([element])),
                                    idPermissao: this.cargo,
                                };
                                await this.$store.dispatch("setNotifyMunicInviteUser", payloadAplicador);
                            });
                            break;
                        }
                    }

                    // Sucesso
                    notyf.open({
                        type: "success", message: "Convite enviado com sucesso!", 
                    });
                    while(this.tags.length) {
                        this.tags.pop();
                    }
                }
            },
        },

        components: {
            Button,
        },
    };
</script>

<style scoped>
    .container {
        width: 100%;
        background-color: white;
    }

    .question-style {
        width: 100%;
        font-size: 1rem;
        font-weight: 500;
        color: #656565;
    }

    .image-style {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 50%;
        padding: 1rem;
    }

    .button-div {
        text-align: right;
        display: flex;
        justify-content: space-around;
    }

    .text-alert-match-passwords {
        color: rgb(224, 53, 53);
        font-weight: 100;
        font-size: 0.9rem;
    }

    .text-alert-valid-email {
        color: rgb(104, 158, 60);
        font-weight: 100;
        font-size: 0.9rem;
    }

    .email-field{
        min-height: calc(2.25rem + 2px);
        height: auto;
    }

    .email-input,.email-input:focus{
        box-shadow: 0 0 0 0;
        border: 0 none;
        outline: 0;
        background-color: transparent;
    }

    .tag{
        list-style: none;
        color: black;
        border-radius: 8px;
        border: 1px #ffac90 solid;
    }

    .remove-icon:hover{
        color: red;
        cursor: pointer;
        transition: all 0.5s;
    }
</style>